import React from 'react';

const Pause = ({ className = '', title = '' }) => {
  return (
    <svg className={className} width="27" height="34" viewBox="0 0 27 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title lang="en">{title}</title>
      <rect width="9" height="34" fill="#FCEE21"/>
      <rect x="18" width="9" height="34" fill="#FCEE21"/>
    </svg>
  )
};

export default Pause;
